class QFCustomFilter {

    constructor(settings = {}){


        // init element classes
        this.container = settings.container ? settings.container : "post-container";
        this.item = settings.item ? settings.item : "post";
        this.itemID = settings.itemID  ? settings.itemID : "data-post-id";
        this.noPosts = settings.noPosts ? settings.noPosts : "custom-filter-no-posts";
        this.loadMore = settings.loadMore ? settings.loadMore : "custom-filter-load-more";
        this.filterContainer = settings.filterContainer ? settings.filterContainer : "filter-container";
        this.sortContainer = settings.sortContainer ?  settings.sortContainer : "sort-container";
        this.selectedFiltersContainer = settings.selectedFiltersContainer ?  settings.selectedFiltersContainer : "selected-filters-wrapper"; 

        // get element ref
        this.containerEl = document.querySelector(`.${this.container}`)
        this.loadMoreEl = document.querySelector(`.${this.loadMore}`)
        this.noPostsEl = document.querySelector(`.${this.noPosts}`)
        this.filterContainerEl = document.querySelector(`.${this.filterContainer}`)
        this.sortContainerEl = document.querySelector(`.${this.sortContainer}`)
        this.selectedFiltersContainerEl = document.querySelector(`.${this.selectedFiltersContainer}`)

        // get formatted post data
        this.postData  = settings.postData ? settings.postData : {};

        // get filtter settings
        this.filterSettings = settings.filterSettings ? settings.filterSettings : {};

        // get post limits
        this.postsToShow = settings.postsToShow ? settings.postsToShow : 12;
        this.loadMoretoShow = settings.loadMoretoShow ? settings.loadMoretoShow : this.postsToShow;

        // get additional options
        this.buildFilters = settings.buildFilters == 'false' ? false : true;
        this.ignoreFilters = settings.ignoreFilters ? settings.ignoreFilters : [];

        // set price range
        this.defaultMinPrice = 0;
        this.defaultMaxPrice = Number.MAX_SAFE_INTEGER;
        this.minPrice = this.defaultMinPrice;
        this.maxPrice = this.defaultMaxPrice;


        this.filterOptions = {};
        this.allPostHtml = {};
        this.currentPostHtml = {};
        this.allowedSortMethods = [
            'default',
            'title_asc',
            'title_dsc',
            'published_at_asc',
            'published_at_dsc',
            'price_asc',
            'price_dsc',
        ]

        this.selectedFilters = [];

        this.sortMethod = 'default';


        this.#init()

    }


    // PRIVATE FUNCTIONS ---

    #init(){
        window.log(`postData:`, this.postData)

        this.#buildAdditionalElements()
        this.#storePostHtml()
        if(this.buildFilters){ this.#buildFilters() }
        this.#urlFilters()
        this.#setUpListeners()

        this.showPosts();
        this.showSelectedFilters();

        let wrapper = document.getElementById("qf-filter-wrapper")
        wrapper.style.overflow = 'unset'
        wrapper.style.maxHeight = 'unset'
    }

    #buildAdditionalElements() {

        // check for no container element
        if(!this.containerEl){
            window.log(`%cQFCustomFilter: ERROR - No element with class ${this.container} found. Please ensure the element exists.`, 'color: red; background: black; padding: 6px;')
            return false;
        }

        // check for load more element
        if(!this.loadMoreEl){
            window.log(`%cQFCustomFilter: WARNING - No element with class ${this.loadMore} found. All posts will be shown be default.`, 'color: orange; background: linear-gradient(45deg, rgba(28,87,126,1) 0%, rgba(70,54,122,1) 100%); padding: 6px;')
            this.postsToShow = Number.MAX_SAFE_INTEGER // if no load more exists show all posts by default
        }

        // check for no posts element
        if(!this.noPostsEl){
            window.log(`%cQFCustomFilter: WARNING - No element with class ${this.noPosts} found. No message will be shown when search criteria returns no results.`, 'color: orange; background: linear-gradient(45deg, rgba(28,87,126,1) 0%, rgba(70,54,122,1) 100%); padding: 6px;')
        } else {
            // hide no posts
            this.noPostsEl.style.display = 'none'
        }


    }

    #storePostHtml() {
        // Store allPostHtml ---
        let filter = this

        let posts = document.querySelectorAll(`.${this.container} .${this.item}`);

        posts.forEach((el, i) => {
            let id = el.getAttribute(`${filter.itemID}`)
            filter.allPostHtml[id] = el;
        })

        this.currentPostHtml = this.allPostHtml;

        window.log(" test ")
        window.log("HTML:", this.currentPostHtml)
    }


    #buildFilters() {
        // Build filters ---
      console.log("this file")
        let filter_html = '';

        const total_ignore_length = this.ignoreFilters.length;
        const totalFilterSettings = Object.keys(this.filterSettings);
        const total_filter_length = totalFilterSettings.length;
        const filter_col_length = total_filter_length - total_ignore_length;

        Object.keys(this.filterSettings).forEach((theme, i) => {

            // window.log("type", typeof this.filterSettings[theme])
            // window.log("settings", this.filterSettings[theme])
            // window.log("theme", theme)
            
            if(this.filterSettings[theme].length > 1 && !this.ignoreFilters.includes(theme)){

                var labelTheme = theme.replace(/_/g, ' ');

                filter_html += `
                                <div class="custom-filter" data-theme="${theme}" style="display: flex; flex-direction: column">
                                    <p class="filter-heading" style="text-transform: capitalize">
                                        <span class="filter-heading-label">${labelTheme}</span>
                                        <span class="close-custom-filter"></span>
                                    </p>
                                    <div class="custom-filter-checkboxes">
                                `;

                let terms = this.filterSettings[theme].sort();
                if ( theme == 'shapes' ) {
                    console.log('this is the theme', theme, terms)
                }
                
                terms.forEach((term) => {
                    filter_html += `
                                    <div class="checkbox-group" data-term="${term}">
                                        <input id="${theme}_${term}" type="checkbox" data-theme="${theme}" data-term="${term}" >
                                        <span for="${theme}_${term}" class="">${term}</span>
                                    </div>`;
                })

                filter_html += '</div></div>';
            }
        })

        // Add filter container if none exists
        if(!this.filterContainerEl){

            let filterContainer = document.createElement('div')
            filterContainer.classList.add(this.filterContainer)
            // filterContainer.style.display = 'flex'
            this.containerEl.parentNode.insertBefore(filterContainer, this.containerEl)

            this.filterContainerEl = filterContainer
        }

        // Add filters to container
        this.filterContainerEl.append(this.htmlToElement(filter_html))
        this.filterContainerEl.classList.add(`filter-length-${filter_col_length}`)

        // Replace type to category
        const typeLabel = document.querySelector('[data-theme="type"] .filter-heading-label')
        if (typeLabel) {
            typeLabel.innerHTML = typeLabel.innerHTML.replace(typeLabel.innerHTML,'Category')
        }

        let category_filter = document.querySelector('[data-theme="type"]');
        if (category_filter) {
            let filter_title = document.title.split("|");
            if (filter_title[0].includes("Lingerie") || filter_title.includes("Nightwear") && category_filter ) {
            category_filter.style.display = "none";
        }
        }

        // Replace vendor to brand
        const vendorLabel = document.querySelector('[data-theme="vendor"] .filter-heading-label')
        if (vendorLabel) {
            vendorLabel.innerHTML = vendorLabel.innerHTML.replace(vendorLabel.innerHTML,'Brand')
        }

        // Replace tags to shape
        const collection_handle = document.querySelector('#collection-grid').dataset.collectionHandle
        const tagsLabel = document.querySelector('[data-theme="shapes"] .filter-heading-label')
        if (tagsLabel) {
            tagsLabel.innerHTML = tagsLabel.innerHTML.replace(tagsLabel.innerHTML,'Style')
            if (collection_handle.includes('lingerie') || collection_handle.includes('new-arrivals') || (collection_handle.includes('swimwear'))) {
                tagsLabel.innerHTML = tagsLabel.innerHTML.replace(tagsLabel.innerHTML,'Style')
            } else if (collection_handle.includes('nightwear')) {
                tagsLabel.innerHTML = tagsLabel.innerHTML.replace(tagsLabel.innerHTML,'Style')
            }
        }

        // Remove undefiend brand
        const brandNull = document.querySelector('[data-theme="vendor"] [data-term="."]')
        if (brandNull) {
            brandNull.remove()
        }

        // Remove undefiend size
        const sizeNull = document.querySelector('[data-theme="size"] #size_undefined')
        if (sizeNull) {
            sizeNull.parentElement.remove()
        }
    }

    #setUpListeners() {

        let filter = this

        // Listen for filter option changes ---
        let filterCheckboxes = document.querySelectorAll(`.${this.filterContainer} input[type=checkbox]`)

        filterCheckboxes.forEach((el) => {

            el.addEventListener('change', () => {
                let checked = el.checked;

                let theme = el.getAttribute("data-theme")
                let term = el.getAttribute("data-term")

                if (term.includes("Preference:")) {
                    term = term.replace("Preference:", "")
                }

                window.log("THEME:", theme)
                window.log("TERM:", term)
                
                // el.parentElement.parentElement.parentElement.classList.remove('hide');

                if(checked){

                    if(!filter.filterOptions.hasOwnProperty(theme)){
                        filter.filterOptions[theme] = [];
                    }

                    filter.filterOptions[theme].push(term);
                    this.selectedFilters.push(term + ':' + theme);
                } else {
                    let index = filter.filterOptions[theme].indexOf(term);
                    if (index > -1) {
                        filter.filterOptions[theme].splice(index, 1);
                    }
                    let index2 = this.selectedFilters.indexOf(term + ':' + theme);
                    if (index2 > -1) {
                        this.selectedFilters.splice(index, 1);
                    }
                }

                window.log("Filter Options:", filter.filterOptions)
                this.showSelectedFilters();
                filter.showPosts()

                // If filters are selected, add class to custom-filter element
                if (filter.filterOptions[theme].length > 0) {
                  document.querySelector('#reset-filters').style.display = 'block'
                  document.querySelector(`.custom-filter[data-theme="${theme}"]`).classList.add('is-active')
                  document.querySelector(`.custom-filter[data-theme="${theme}"] .filter-heading-label`).innerHTML += `<span class="label-counter"></span>`
                  document.querySelector(`.custom-filter[data-theme="${theme}"] .filter-heading-label .label-counter`).innerHTML = `(${this.filterOptions[theme].length})`
                } else {
                  document.querySelector('#reset-filters').style.display = 'none'
                  document.querySelector(`.custom-filter[data-theme="${theme}"]`).classList.remove('is-active')
                  document.querySelector(`.custom-filter[data-theme="${theme}"] .filter-heading-label .label-counter`).remove()
                }
            })


        })

        // Show filter
        let openFilters = document.querySelector(`.openCollectionFilters`)
        openFilters.addEventListener('click', () => {
            document.querySelector('.filter-container-wrapper').classList.add('active')
        })

        // Close filter
        let closeFilters = document.querySelector(`.desktop-close-filters`)
        closeFilters.addEventListener('click', () => {
            document.querySelector('.filter-container-wrapper').classList.remove('active')
        })


        // Hide filter groups


        let filterContainer = document.querySelectorAll(`.custom-filter`)

        
         
        document.addEventListener('click', event => {
            filterContainer.forEach((el) => { 
                let closeCustomFilter = el.querySelector('.filter-heading')
                let closeFilter = el.querySelector(`.custom-filter-checkboxes`)
                
                const isClickInside = closeFilter.contains(event.target)
                const isFilterTitle = closeCustomFilter.contains(event.target)
                if (isFilterTitle) {
                    el.classList.toggle('hide')
                } else if (!isClickInside) {
                    el.classList.remove('hide')
                }
            })
        })

        
        // Load More ---
        this.loadMoreEl.addEventListener('click', () => {
            filter.postsToShow += filter.loadMoretoShow;
            filter.showPosts();
        })


        // Sort
        if(this.sortContainerEl){
            let sort_select = document.querySelector(`.${this.sortContainer} select`)

            sort_select.addEventListener('change', () => {
                let sortMethod = sort_select.value
                if(this.allowedSortMethods.includes(sortMethod)){
                    this.sortMethod = sortMethod
                    filter.showPosts()
                } else {
                    window.log(`${sortMethod} is not a vaild sort option`)
                }
            })

            const changeSelected = (value) => {
              sort_select.value = value

              let sortMethod = sort_select.value
              if(this.allowedSortMethods.includes(sortMethod)){
                  this.sortMethod = sortMethod
                  filter.showPosts()

              } else {
                  window.log(`${sortMethod} is not a vaild sort option`)
              }
            };

            let sortFilterLinks = document.querySelectorAll(".custom-filter-sort a")
            sortFilterLinks.forEach((link) => {
                link.addEventListener('click', e =>{
                    let newValue = link.getAttribute('data-id')
                    changeSelected(newValue)

                    sortFilterLinks.forEach(el => el.classList.remove('active'))
                    link.classList.add('active')

                    link.parentElement.parentElement.classList.remove('hide')
                });
            })
        }

        // Price Range
        let rangeInputs = document.querySelectorAll("#price-container .range-input input")
        rangeInputs.forEach((input) => {
            input.addEventListener("input", e =>{
                let minPrice = parseInt(rangeInputs[0].value);
                let maxPrice = parseInt(rangeInputs[1].value);

                filter.minPrice = minPrice * 100
                filter.maxPrice = maxPrice * 100
            });
        })


        // Apply Price range - (price range will be used next time filter options are change. This listener filters when the apply button is pressed)
        let applyPriceMin = document.querySelector('#price-container .range-min')
        let applyPriceMax = document.querySelector('#price-container .range-max')

        applyPriceMin.addEventListener('change', () => {
            filter.showPosts()
        })
        applyPriceMax.addEventListener('change', () => {
            filter.showPosts()
        })


        // Reset filters
        let reset = document.querySelector('#reset-filters')
        reset.addEventListener('click', () => {
          let activeFilters = document.querySelectorAll('input[type="checkbox"]:checked')
          activeFilters.forEach((el) => {
              el.click();
          })

          console.log('Reset filter');

          // Reset sort filter
          let changeEvent = new Event('change');
          let sortSelect = document.querySelector('.custom-filter-sort select')
          sortSelect.value = 'default'
          sortSelect.dispatchEvent(changeEvent);

          let sortFilterLinks = document.querySelectorAll(".custom-filter-sort a")
          sortFilterLinks.forEach((link) => {
            sortFilterLinks.forEach(el => el.classList.remove('active'))
          })

          //reset.parentNode.removeChild(reset)
        })

    }

    showSelectedFilters(){
        this.selectedFiltersContainerEl.innerHTML = '';

        this.selectedFilters.forEach(filter =>{
            let filter_term = filter.split(':')[0];
            this.selectedFiltersContainerEl.innerHTML += `
                <div class="selected-filter">
                    ${filter_term}
                    <svg data-term="${filter}" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                        <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                    </svg>
                </div>`;
        })

        

        let selectedFilterTabs = document.querySelectorAll('.selected-filter svg');

        selectedFilterTabs.forEach(selectedFilterTab => {
            selectedFilterTab.addEventListener('click', (e) => {
                let filter_name = selectedFilterTab.dataset.term;
                let theme = filter_name.split(":")[1];
                let term = filter_name.split(":")[0];
                let checkboxes = document.querySelectorAll(`.custom-filter input[data-theme='${theme}']`);
                checkboxes.forEach(checkbox => {
                    if(checkbox.dataset.term === term) {
                        checkbox.checked = false;

                        let index = this.selectedFilters.indexOf(filter_name);
                        if (index > -1) {
                            this.selectedFilters.splice(index, 1);
                        }

                        selectedFilterTab.parentElement.remove();
        
                        let event = new Event('change');
                        checkbox.dispatchEvent(event);
                    }
                })
            })
        })
    }

    #getPosts(){

        // Show all if if no filter options have been selected
        var filterOptionsCount = 0;
        for(let key in this.filterOptions){
            filterOptionsCount += this.filterOptions[key].length;
        }

        if(filterOptionsCount == 0 && (this.minPrice == this.defaultMinPrice && this.maxPrice == this.defaultMaxPrice)){
            return this.allPostHtml;
        } else {
            return this.#filterPosts();
        }

    }

    #filterPosts(){

        // find posts that match filter options
        let filtered_posts = [];

        // window.log("FILTER OPTIONS: ", this.filterOptions)

        for(let key in this.postData){

            if(this.#inPriceRange(key)){

                // window.log(">",key)

              	let found = true;
                // window.log("PRODUCT DATA", this.postData[key])
                for(let theme in this.postData[key]){
                    let terms = this.postData[key][theme]
                    // window.log(">>>", theme)

                    if(this.filterOptions.hasOwnProperty(theme) && this.filterOptions[theme].length > 0){
                    	found = this.filterOptions[theme].some(el => terms.indexOf(el) >= 0)
                    }

                    if(!found){
                    	break;
                    }
                }

                if(found){
                    filtered_posts.push(key)
                }

            }

        }

        window.log("FILTERED: ", filtered_posts, "Length: ", filtered_posts.length)

        let filteredPostHtml = {};

        filtered_posts.forEach(postId => {
            filteredPostHtml[postId] = this.allPostHtml[postId];
        });

        return filteredPostHtml;

    }

    #inPriceRange(product_id){
        let price = this.postData[product_id].price
        return ((this.minPrice <= price) && (price <= this.maxPrice))
    }

    #urlFilters(){

        let queryString = window.location.search;

        if(queryString != ''){
            let queryParts = queryString.substring(1).split('&')
            let urlQuery = {}

            queryParts.forEach((part) => {
                let themeQuery = part.split('=')
                let searchTheme  = themeQuery[0];
                let searchTerms  = themeQuery[1].split('+');
                searchTerms = searchTerms.map((term) => {
                    return decodeURIComponent(term)
                })

                urlQuery[searchTheme] = searchTerms


            })



            for(let theme in this.filterSettings){

                let searchTerms = Object.keys(urlQuery).includes(theme) ? urlQuery[theme] : null

                if(searchTerms){

                    searchTerms.forEach((term) => {

                        // if term is a valid setting, add to options
                        let termsForTheme = this.filterSettings[theme]

                        window.log("term", term, termsForTheme)


                        if(Object.values(termsForTheme).includes(term)){

                            // init as array if not yet defined
                            if(!this.filterOptions[theme]){
                                this.filterOptions[theme] = [];
                            }

                            // Add term to filter options
                            this.filterOptions[theme].push(term)

                            // check relevant checkbox
                            let termInput = document.querySelector(`[data-theme="${theme}"][data-term="${term}"]`)
                            termInput.checked = true

                            // Add Selected filters
                            this.selectedFilters.push(term + ':' + theme)

                            this.showSelectedFilters();

                            // If filters are selected, add class to custom-filter element
                            if (theme) {
                              document.querySelector('#reset-filters').style.display = 'block'
                              document.querySelector(`.custom-filter[data-theme="${theme}"]`).classList.add('is-active')
                              document.querySelector(`.custom-filter[data-theme="${theme}"] .filter-heading-label`).innerHTML += `<span class="label-counter"></span>`
                              document.querySelector(`.custom-filter[data-theme="${theme}"] .filter-heading-label .label-counter`).innerHTML = `(${this.filterOptions[theme].length})`
                            } else {
                              document.querySelector('#reset-filters').style.display = 'none'
                              document.querySelector(`.custom-filter[data-theme="${theme}"]`).classList.remove('is-active')
                              document.querySelector(`.custom-filter[data-theme="${theme}"] .filter-heading-label .label-counter`).remove()
                            }
                        }

                    })

                }

            }

        }




    }

    #setUrlParams(){

        if(Object.keys(this.filterOptions).length > 0){
            let searchParams = '?'

            // console.log("OPT:", this.filterOptions)

            for(let theme in this.filterOptions){
                searchParams = searchParams + `${theme}=`
                let terms = this.filterOptions[theme]
                terms = terms.map((term) => {
                    return encodeURIComponent(term)
                })
                // console.log(">terms", terms)
                terms = terms.join('+')
                // console.log(">>terms", terms)
                // terms = encodeURI(terms)
                // console.log(">>>terms", terms)

                searchParams = searchParams + terms + "&"

            }

            searchParams = searchParams.substring(0, searchParams.length - 1)
            // console.log("NEW PARAMS:", searchParams)

            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + searchParams;
            window.history.pushState({path:newurl},'',newurl);
        }

    }


    showPosts(){

        window.log("SHOWING POSTS")

        // Set currentPostHtml
        let postHtml = this.#getPosts()
        this.currentPostHtml = postHtml;



        this.clearPosts();

        let postsAdded = 0;
        let i = 0;

        if(this.sortMethod != 'default'){

            let sortOrder = this.#sortPosts(postHtml);
            for(let i = 0; i < sortOrder.length; i++){
                // if(i >= toShowLowerLimit){
                //     $(postContainer).append(postHtml[sortOrder[i]])
                //     postsAdded++
                // }

                this.containerEl.append(postHtml[sortOrder[i]])
                postsAdded++

                if(postsAdded >= this.postsToShow){ break; }
            }

        } else {

            let productIds = Object.keys(postHtml)
            for(let i = 0; i < productIds.length; i++){

                this.containerEl.append(postHtml[productIds[i]])
                postsAdded++

                if(postsAdded >= this.postsToShow){ break; }
            }

        }

        // Show/Hide no posts message
        if(postsAdded == 0){
            this.noPostsEl.style.display = 'table'
        } else {
            this.noPostsEl.style.display = 'none'
        }


        // Show/Hide load more
        let totalPostCount = Object.keys(postHtml).length;

        if(totalPostCount <= this.postsToShow){
            this.loadMoreEl.style.display = 'none'
        } else {
            this.loadMoreEl.style.display = 'table'

        }

        this.#setUrlParams()

        return postHtml
    }

    #sortPosts(postHtml){
        // window.log("SORTING")

        let sortOrder = Object.keys(postHtml);

        // window.log("ORDER BEFORE", sortOrder)

        switch(this.sortMethod){
            case 'published_at_asc':
                sortOrder.sort((a,b) => {
                    return this.postData[a]['published_at'] - this.postData[b]['published_at'];
                })
                break;

            case 'published_at_dsc':
                sortOrder.sort((a,b) => {
                    return this.postData[b]['published_at'] - this.postData[a]['published_at'];
                })
            break;

            case 'price_asc':
                sortOrder.sort((a,b) => {
                    return this.postData[a]['price'] - this.postData[b]['price'];
                })
                break;

            case 'price_dsc':
                sortOrder.sort((a,b) => {
                    return this.postData[b]['price'] - this.postData[a]['price'];
                })
                break;

            case 'title_asc':
                sortOrder.sort((a,b) => {
                    return this.postData[a]['title'].localeCompare(this.postData[b]['title']);
                })
                break;

            case 'title_dsc':
                sortOrder.sort((a,b) => {
                    return this.postData[b]['title'].localeCompare(this.postData[a]['title']);
                })
                break;

            // case 'favourites':
            //     sortOrder.sort(function(a,b){
            //         return this.postData[b]['is_favourite'] - this.postData[a]['is_favourite'];
            //     })
            //     break;

            // case 'collab':
            //     sortOrder.sort(function(a,b){
            //         return this.postData[b]['is_collab'] - this.postData[a]['is_collab'];
            //     })
            //     break;
        }

        // window.log("ORDER AFTER", sortOrder)

        return sortOrder;
    }

    // HELPER FUNCITONS

    // Takes an html sting and returns it as an element
    htmlToElement(html) {
        var template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content;
    }


    // PUBLIC FUNCTIONS
    clearPosts(){
        let posts = document.querySelectorAll(`.${this.container} .${this.item}`);

        posts.forEach((el, i) => {
            el.parentNode.removeChild(el)
        })

    }
    
}
